export class Tag {
    constructor(
        public Usage: string,
        public Id: number = undefined,
        public CreatedDate: Date = undefined,
        public Name: string = "") {
    }
}
